import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { ArrowLeft, Check, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ success }) {
  const [state, setState] = useState(success ? "pending" : "cancelled");
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    if (!success) return;
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setState("paid"); setOrderId(r.data.order_id); return; }
      } catch { /* retry */ }
      if (++tries < 15) timer = setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
    return () => clearTimeout(timer);
  }, [success]);

  return (
    <div className="vf-payment-page" data-testid="payment-result-page">
      <motion.div className="vf-modal vf-success" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}>
        {state === "pending" && <>
          <div className="vf-spinner" data-testid="payment-pending-spinner" />
          <h2>Vérification du paiement…</h2>
          <p>Nous confirmons votre paiement auprès de notre partenaire sécurisé.</p>
        </>}
        {state === "paid" && <>
          <div className="vf-success-check"><Check size={24} /></div>
          <p className="vf-kicker vf-kicker-center">Paiement confirmé</p>
          <h2>Merci pour votre commande</h2>
          <p>Votre commande <b data-testid="payment-order-number">{orderId}</b> est payée et confirmée. Vous recevrez un email de confirmation très vite.</p>
          <a className="vf-cta" href="/" data-testid="payment-back-home">Continuer mes achats</a>
        </>}
        {state === "cancelled" && <>
          <div className="vf-cancel-icon"><XCircle size={26} /></div>
          <p className="vf-kicker vf-kicker-center">Paiement annulé</p>
          <h2>Aucun montant débité</h2>
          <p>Votre paiement a été annulé. Vos articles vous attendent dans la boutique.</p>
          <a className="vf-cta" href="/" data-testid="payment-back-home"><ArrowLeft size={16} /> Retour à la boutique</a>
        </>}
        {state === "error" && <>
          <div className="vf-cancel-icon"><XCircle size={26} /></div>
          <h2>Vérification impossible</h2>
          <p>Si votre paiement a bien été débité, votre commande est enregistrée. Contactez-nous en cas de doute.</p>
          <a className="vf-cta" href="/" data-testid="payment-back-home">Retour à la boutique</a>
        </>}
      </motion.div>
    </div>
  );
}
